export const LOAD_BALANCES = 'LOAD_BALANCES';
